export var getOverflowParents = function(element) {
    var parents = [];
    var node = element;
    while((node = node.parentElement) && node !== document.body){
        getComputedStyle(node).overflow !== "visible" && parents.push(node);
    }
    return parents;
};
export var getOverflowParentDimensions = function(element, excludeClosestParent, expandToViewport, canExpandOutsideViewport) {
    if (excludeClosestParent === void 0) {
        excludeClosestParent = false;
    }
    if (expandToViewport === void 0) {
        expandToViewport = false;
    }
    if (canExpandOutsideViewport === void 0) {
        canExpandOutsideViewport = false;
    }
    var parents = expandToViewport ? [] : getOverflowParents(element).map(function(el) {
        var _a = el.getBoundingClientRect(), height = _a.height, width = _a.width, top = _a.top, left = _a.left;
        return {
            // Treat the whole scrollable area as the available height
            // if we're allowed to expand past the viewport.
            height: canExpandOutsideViewport ? el.scrollHeight : height,
            width: width,
            top: top,
            left: left
        };
    });
    if (canExpandOutsideViewport && !expandToViewport) {
        var documentDimensions = document.documentElement.getBoundingClientRect();
        parents.push({
            width: Math.max(documentDimensions.width, document.documentElement.clientWidth),
            height: Math.max(documentDimensions.height, document.documentElement.clientHeight),
            top: documentDimensions.top,
            left: documentDimensions.left
        });
    } else {
        parents.push({
            height: window.innerHeight,
            width: window.innerWidth,
            top: 0,
            left: 0
        });
    }
    if (excludeClosestParent && !expandToViewport) {
        parents.shift();
    }
    return parents;
};
/**
 * Calls `scrollIntoView` on the provided element with sensible defaults. If
 * the element does not existed or does not support the `scrollIntoView`
 * method, it will do nothing. This wrapper is created to support environments
 * where the native function is not available like JSDom (feature request:
 * https://github.com/jsdom/jsdom/issues/1422).
 *
 * @param element to be scrolled into view
 * @param options native options for `scrollIntoView`
 */ export function scrollElementIntoView(element, options) {
    var _a;
    if (options === void 0) {
        options = {
            block: "nearest",
            inline: "nearest"
        };
    }
    (_a = element === null || element === void 0 ? void 0 : element.scrollIntoView) === null || _a === void 0 ? void 0 : _a.call(element, options);
} //# sourceMappingURL=scrollable-containers.js.map
